// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cloud-frm-grl{background:#3d4244;border-radius:6px;height:600px;color:#000;border-color:#3d4244;margin-top:5px;margin-left:5px}.rsl-row-Info{padding-bottom:3px}.rsl-polla-lb1{color:yellow}.rsl-polla-vl1{color:#fff}.rsm-info-polla{background:#3d4244}.inf-alt{background:lightslategrey}.rsm-info-alert{margin-left:30px}.frm-col-Polla{padding-top:100px}\n", ""]);
// Exports
module.exports = exports;
